import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { RootState } from "../../../app/store";
import CloseButton from "../../../components/shared-components/CloseButton";
import footerLinks from "../../../fakedata/footerurl.json";
import { selectTheme } from "../../../features/theme/themeSlice";
import HeaderLinks from "./HeaderLinks";

type FirstFooterLinksProps = {
  onClose?: () => void;
};

const FirstFooterLinks = ({ onClose }: FirstFooterLinksProps) => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();
  return visible ? (
    !theme.isTablet ? (
      <section className="first-footer-links">
        <div className={`first-footer-links-section d-flex`}>
          <div className="fl-left">&nbsp;</div>
          <div className="fl-center" style={{ flexGrow: "2" }}>
            {footerLinks && (
              <ul className="ul-footer-link">
                {footerLinks.map((l, i) => {
                  return (
                    <li
                      key={`li-${i}`}
                      className={`footer-link-item ${
                        l.enabled ? "pointer" : ""
                      }`}
                      onClick={() => {
                        l.enabled && navigate(`page/${l.path}`);
                      }}
                    >
                      <FormattedMessage id={l.label} />
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          <div className="footer-light-icons">
            <HeaderLinks menuInverse noshowTicket/>
          </div>

          <div className="fl-right">
            {!theme.isTablet && (
              <CloseButton
                onClose={() => {
                  onClose && onClose();
                  setVisible(false);
                }}
              />
            )}
          </div>
        </div>
      </section>
    ) : (
      <div></div>
    )
  ) : (
    <div></div>
  );
};

export default FirstFooterLinks;
